import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {
  getColumnKey,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import {
  AdminCosmeticCollectionFilter,
  AdminCosmeticCollectionItem,
} from '@web/shared/module/cosmetic';
import { isNotNil } from '@web/utils';
import { AdminCosmeticStatusComponent } from '../admin-cosmetic-status/admin-cosmetic-status.component';

@Component({
  selector: 'app-admin-cosmetic-list-custom-cell-template',
  imports: [
    ImageThumbnailComponent,
    TableBodyNoReferenceCellComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    NoDataComponent,
    AdminCosmeticStatusComponent,
  ],
  templateUrl: './admin-cosmetic-list-custom-cell-template.component.html',
  styleUrl: './admin-cosmetic-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminCosmeticListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminCosmeticCollectionItem, AdminCosmeticCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminCosmeticCollectionItem>();

  protected readonly getColumnKey = getColumnKey<AdminCosmeticCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
